import { Component, ViewChild, ViewContainerRef, HostListener, AfterViewInit, ChangeDetectorRef, ComponentFactoryResolver, Input } from '@angular/core';
import { TemplateListsPage } from '../../pages/template-lists/template-lists';
import { AlertController, Events, ModalController, NavController, NavParams } from 'ionic-angular';
import { FolderSecurityPropertyComponent } from '../../components/folder-security-property/folder-security-property';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ToastController } from 'ionic-angular';
import { componentHolderService } from '../../providers/component-holder.service/component-holder.service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'folder-properties',
  templateUrl: 'folder-properties.html'
})
export class FolderPropertiesComponent {

  text: string;
  tab2Root: any;
  tab3Root: any;
  tab1Root: any;
  navTemplate: any;
  @Input() selectTemplates: any = [];
  @Input() templateType: any;
  @Input() shareInfo: any;
  @Input() objCurrentFolder: any;
  @Input() objCurrentTemplateProps: any;
  folderAccess: any = "";
  ImportExportFolderAccess: any = 'export'
  componentRef: any;
  screenProps: any;
  @Input() exportFolder: boolean
  @Input() exportFolderStatus: any;
  tmAppUrl: string;
  urlSafe: any;
  constructor(private resolver: ComponentFactoryResolver, public navParams: NavParams, public sanitizer: DomSanitizer, private EncrDecrService: EncrDecrServiceProvider, public configServiceProvider: ConfigureServiceProvider, public driveService: DriveServiceProvider, public configApiService: ConfigApiServiceProvider, public navCtrl: NavController, public events: Events, private cdr: ChangeDetectorRef, public configureService: ConfigureServiceProvider, public driveServiceProvider: DriveServiceProvider, private modal: ModalController, private alertCtrl: AlertController, public toastController: ToastController, private componentService: componentHolderService) {
    this.exportFolderProperties()
  }

  ngOnInit() {
    if (this.driveService.adminAccess || this.driveService.clientAdminAccess) {
      this.folderAccess = 'Security'
    }else{
      this.folderAccess = 'template'
    }
    this.tab1Root = TemplateListsPage;
    this.tab2Root = TemplateListsPage;
    this.tab3Root = TemplateListsPage;
    this.navTemplate = TemplateListsPage;
  }

  segmentChanged(ev: any) {
    if (ev.value == "trackSetup") {
      Object.keys(this.driveService.storeWrap.storeTemplates).forEach(temp => {
        if (this.driveService.storeWrap.storeTemplates[temp].templateName == "TracknTraceSetup") {

          this.screenProps = this.driveService.storeWrap.storeTemplates[temp];
        }
      });
    }

  }

  @ViewChild('templateProperties', { read: ViewContainerRef, static: true }) templateProperties: ViewContainerRef;
  @ViewChild('container', { read: ViewContainerRef, static: false }) viewContainerRef: ViewContainerRef;
  loadTemplateProperty() {
    if (this.templateProperties != undefined) {
      this.viewContainerRef.clear();
    }
    const componentFactory = this.resolver.resolveComponentFactory(TemplateListsPage);
    this.componentRef = this.templateProperties.createComponent(componentFactory);
    this.componentRef.instance.selectTemplates = this.selectTemplates;
    this.componentRef.instance.templateType = 'Multiple';
  }


  closeFolderProperties() {
    this.driveService.broadcastInfo({ src: 'drive-main', event: 'folderPropertyClose',status: true });
  }

  exportFolderProperties() {
    this.urlSafe = undefined;
    //this.configApiService.templateMangerUrl = 'http://localhost:8101/?server=local&host=https://prodcast.cloud:3780'
    let urlParams = '&appCode=' + this.configApiService.currentDriveApp['app_code'] + '&studio=' + this.configureService.getStudio() + '&userid=' + this.configureService.getLoginUserID() + '&exportFolder='
    let encUrlParams = this.EncrDecrService.encrypt('DRIVESYNC123##', urlParams);
    this.tmAppUrl = this.configApiService.templateMangerUrl + '&templateParams=' + encUrlParams;
    if (this.urlSafe == undefined) {
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.tmAppUrl);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/folder-properties/folder-properties.ts